import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

let youtubeApiPromise;
function loadYouTubeApi() {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (!youtubeApiPromise) {
    youtubeApiPromise = new Promise((resolve) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => { previous?.(); resolve(window.YT); };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(script);
      }
    });
  }
  return youtubeApiPromise;
}

const SponsoredVideoPreview = forwardRef(({ video, onTimeChange, onDuration }, ref) => {
  const hostRef = useRef(null);
  const mediaRef = useRef(null);
  const [ready, setReady] = useState(false);

  useImperativeHandle(ref, () => ({
    getCurrentTime: () => Number(mediaRef.current?.getCurrentTime?.() ?? mediaRef.current?.currentTime ?? 0),
    seekTo: (seconds) => mediaRef.current?.seekTo ? mediaRef.current.seekTo(seconds, true) : mediaRef.current && (mediaRef.current.currentTime = seconds),
  }));

  useEffect(() => {
    if (video.sourceType !== 'youtube') return undefined;
    let disposed = false;
    loadYouTubeApi().then((YT) => {
      if (disposed || !hostRef.current) return;
      mediaRef.current = new YT.Player(hostRef.current, {
        videoId: video.sourceContentId,
        playerVars: { controls: 1, rel: 0 },
        events: { onReady: (event) => { setReady(true); onDuration(event.target.getDuration()); } },
      });
    });
    return () => { disposed = true; mediaRef.current?.destroy?.(); mediaRef.current = null; };
  }, [video.sourceContentId, video.sourceType, onDuration]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      if (!ready && video.sourceType === 'youtube') return;
      const time = Number(mediaRef.current?.getCurrentTime?.() ?? mediaRef.current?.currentTime ?? 0);
      onTimeChange(time);
    }, 250);
    return () => window.clearInterval(timer);
  }, [onTimeChange, ready, video.sourceType]);

  if (video.sourceType === 'youtube') return <div className="sponsored-preview__media" ref={hostRef} />;
  return <video ref={mediaRef} className="sponsored-preview__media" src={video.previewSourceUrl || video.sourceContentId} controls onLoadedMetadata={(event) => { setReady(true); onDuration(event.currentTarget.duration); }} />;
});

export default SponsoredVideoPreview;
